import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import type { ProductPlanI18nFormModel } from "../../../model/type";

type QueryData = ProductPlanI18nFormModel["QueryData"];
type ViewModel = ProductPlanI18nFormModel["ViewModel"];

export type ProductPlanI18nFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
};

export const ProductPlanI18nFormModelContext = createContext<ProductPlanI18nFormModelContextType | null>(null);

export const useProductPlanI18nFormModelContext = () => {
	const context = useContext(ProductPlanI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductPlanI18nFormModelContext must be used within a ProductPlanI18nFormModelContext.Provider",
		);
	}

	return context;
};
